import { SVGProps } from "react"
const FilterNewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="34" height="34" rx="7.5" fill="white" />
    <rect x="0.5" y="0.5" width="34" height="34" rx="7.5" stroke={props.fill || "#1F375D"} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 9.75C12.0188 9.75 13.25 10.9812 13.25 12.5C13.25 14.0188 12.0188 15.25 10.5 15.25C8.98122 15.25 7.75 14.0188 7.75 12.5C7.75 10.9812 8.98122 9.75 10.5 9.75ZM11.75 12.5C11.75 11.8096 11.1904 11.25 10.5 11.25C9.80964 11.25 9.25 11.8096 9.25 12.5C9.25 13.1904 9.80964 13.75 10.5 13.75C11.1904 13.75 11.75 13.1904 11.75 12.5Z"
      fill={props.fill || "#1F375D"}
    />
    <path
      d="M16.5 11.75C16.0858 11.75 15.75 12.0858 15.75 12.5C15.75 12.9142 16.0858 13.25 16.5 13.25L26.5 13.25C26.9142 13.25 27.25 12.9142 27.25 12.5C27.25 12.0858 26.9142 11.75 26.5 11.75L16.5 11.75Z"
      fill={props.fill || "#1F375D"}
    />
    <path
      d="M19.25 22.5C19.25 22.0858 18.9142 21.75 18.5 21.75L8.5 21.75C8.08579 21.75 7.75 22.0858 7.75 22.5C7.75 22.9142 8.08579 23.25 8.5 23.25L18.5 23.25C18.9142 23.25 19.25 22.9142 19.25 22.5Z"
      fill={props.fill || "#1F375D"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5 19.75C22.9812 19.75 21.75 20.9812 21.75 22.5C21.75 24.0188 22.9812 25.25 24.5 25.25C26.0188 25.25 27.25 24.0188 27.25 22.5C27.25 20.9812 26.0188 19.75 24.5 19.75ZM23.25 22.5C23.25 21.8096 23.8096 21.25 24.5 21.25C25.1904 21.25 25.75 21.8096 25.75 22.5C25.75 23.1904 25.1904 23.75 24.5 23.75C23.8096 23.75 23.25 23.1904 23.25 22.5Z"
      fill={props.fill || "#1F375D"}
    />
  </svg>
)
export default FilterNewIcon
